export const sampleToken = {
  metadata: {
    name: 'Benu Yu Crypto',
    description:
      'Certificate for Benu Yu Crypto for graduating course Ben Yu Cryto Course (Class 007)',
    image:
      'https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/NFT_CERTIFICATE_IMAGES/Certificate1.jpg',
    attributes: {
      courseName: 'How To Master NFTs in 7 Days',
      graduationDate: '10-Feb-2022',
      classNumber: '007',
      displayName: 'Mark Vu',
    },
  },
  tokenId: 11,
};

export const sampleCourse = {};

export const TOKEN_PAGE_CLAIM_CONST = 'claim';
